import axios from 'axios'

const ReceivingService = {
  async get (params = {}) {
    return axios.get('ro/purchase-order/receivings', { params })
  },

  async histories (params = {}) {
    return axios.get('ro/reports/purchase-order/receiving-histories', { params })
  },

  async exports (params = {}) {
    return axios.get('ro/exports/purchase-order/receivings', { params })
  },

  async show (id) {
    return axios.get(`ro/purchase-order/receivings/${id}`)
  },

  async post (params = {}) {
    return axios.post('ro/purchase-order/receivings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`ro/purchase-order/receivings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`ro/purchase-order/receivings/${data.id}`, { data })
  }
}

export default ReceivingService
